import { Component, OnInit } from '@angular/core';
import { Form } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/db/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {

  currentUser: User;

  // signOutform: Form;

  constructor(private authenticate: AuthenticationService,
              private router: Router,
              private notify: ToastrService)
  {
    this.authenticate.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit() {
  }

  logOut():void {
    this.authenticate.logout();
    this.router.navigate(['/']);
    this.notify.success('Logged Out Succesfully');
  }

}
